var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{class:['intro-text', {
               'w-controls' : _vm.withControls
             }],attrs:{"data-aos":"fade-in"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})]),(_vm.subText)?_c('p',{attrs:{"data-aos":"fade-in"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.subText)}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }